import React, {
  useState, useEffect, forwardRef, useImperativeHandle
} from 'react';
import { useDispatch } from 'react-redux';
import {
  Grid,
  TextField,
  Typography,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Tooltip,
  IconButton,
  SvgIcon,
  Menu,
  FormGroup,
  Button,
  Checkbox,
} from '@material-ui/core';
import { Columns as ColumnIcon } from 'react-feather';
import PropTypes from 'prop-types';
import axios from 'src/utils/axios';
import { getQueues, getTickets } from 'src/actions/queueActions';
import { useParams } from 'react-router';
import useQuery from 'src/utils/useQuery';

const QueueEditNew = forwardRef(({ id }, ref) => {
  const [name, setName] = useState('');
  const [filter, setFilter] = useState('');
  const [orderBy, setOrderBy] = useState('');
  const [orderByDirection, setOrderByDirection] = useState('ASC');
  const [columns, setColumns] = useState([]);
  const [shownColumns, setShownColumns] = useState([]);
  const [anchorEl, setAnchorEl] = useState(null);
  const dispatch = useDispatch();
  const {
    queueId,
    page = 1,
    recordsPerPage = 50,
  } = useParams();
  const {
    q, order, dir, asAtDate,
  } = useQuery(window.location.search);

  const avaliableColumns = ['Id', 'Summary', 'Description', 'Priority', 'Type',
    'Status', 'Reporter', 'Assignee', 'Organisation', 'CreatedDateTime',
    'LastModifiedDateTime', 'ResolvedDateTime', 'EstimatedTime'];

  useImperativeHandle(ref, () => ({

    save() {
      const data = {
        columns,
        name,
        filter,
        orderBy,
        orderByDesc: orderByDirection === 'DESC'
      };

      if (id === 'New') {
        axios.post('/api/queue', JSON.stringify(data))
          .then(() => {
            dispatch(getQueues());
          })
          .catch((error) => {
            console.error(error);
          });
      } else {
        axios.put(`/api/queue/${id}`, JSON.stringify(data))
          .then(() => {
            dispatch(getTickets({
              queueId,
              q,
              order,
              dir,
              columns,
              asAtDate,
              page,
              recordsPerPage,
            }));
          })
          .catch((error) => {
            console.error(error);
          });
      }
    }
  }));

  const handleColumnChange = (column) => {
    if (column.target.checked) {
      const newColumns = [...shownColumns];
      newColumns.push({ key: column.target.name, value: column.target.name });
      setShownColumns(newColumns);
    } else {
      const newColumns = [...shownColumns.filter((x) => x.key !== column.target.name)];
      setShownColumns(newColumns);
    }
  };

  const handleColumnChooserClick = (event) => {
    setShownColumns(columns);
    setAnchorEl(event.currentTarget);
  };

  const handleColumnChooserClose = (updateColumns) => {
    setAnchorEl(null);
    if (updateColumns === 'update') {
      setColumns(shownColumns);
    }
  };

  useEffect(() => {
    setName('');
    setFilter('');
    setOrderBy('');
    setOrderByDirection('ASC');

    if (id === 'New') { return; }

    axios.get(`/api/queue/${id}`)
      .then((response) => {
        setShownColumns(response.data.columns);
        setColumns(response.data.columns);
        setName(response.data.name);
        setFilter(response.data.filter);
        setOrderBy(response.data.orderBy);
        setOrderByDirection((response.data.orderByDesc ? 'DESC' : 'ASC'));
      });
  }, [id]);

  return (
    <div>
      <Grid
        container
        direction="row"
        justify="flex-end"
        alignItems="flex-start"
        style={{ marginTop: -13 }}
      >
        <Tooltip title="Column Chooser">
          <IconButton size="small" onClick={handleColumnChooserClick}>
            <SvgIcon>
              <ColumnIcon />
            </SvgIcon>
          </IconButton>
        </Tooltip>

        <Menu
          anchorEl={anchorEl}
          keepMounted
          open={Boolean(anchorEl)}
          onClose={handleColumnChooserClose}
          style={{ marginLeft: 60, marginTop: 230 }}
        >
          <FormGroup style={{
            marginRight: -2, marginLeft: -2, marginTop: -9, marginBottom: -8
          }}
          >
            {avaliableColumns.map((column) => (

              <FormControlLabel
                style={{ marginLeft: 2 }}
                key={column}
                      // eslint-disable-next-line
                      control={<Checkbox checked={shownColumns && shownColumns.filter((x)=> x.key === column).length > 0} onChange={handleColumnChange} name={column} />}
                label={column}
              />
            ))}
            <Grid
              container
              direction="row"
              justify="space-evenly"
              alignItems="flex-start"
              style={{ paddingBottom: 10 }}
            >

              <Button onClick={() => { handleColumnChooserClose('update'); }} color="secondary" variant="contained">
                Ok
              </Button>

              <Button onClick={handleColumnChooserClose} color="primary">
                Cancel
              </Button>

            </Grid>
          </FormGroup>
        </Menu>

      </Grid>

      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
      >
        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
          style={{ marginRight: 57 }}
        >
          Name
        </Typography>

        <TextField
          variant="outlined"
          margin="dense"
          fullWidth
          value={name}
          onChange={(e) => setName(e.target.value)}
          style={{ marginBottom: 10 }}
        />

      </Grid>

      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
      >
        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
          style={{ marginRight: 57 }}
        >
          Filter
        </Typography>

        <TextField
          variant="outlined"
          margin="dense"
          fullWidth
          value={filter}
          onChange={(e) => setFilter(e.target.value)}
          style={{ marginBottom: 10 }}
        />

      </Grid>

      <Grid
        container
        direction="row"
        justify="flex-start"
        alignItems="center"
      >
        <Typography
          variant="body2"
          color="textSecondary"
          align="center"
          style={{ marginRight: 57 }}
        >
          Order By
        </Typography>

        <TextField
          variant="outlined"
          margin="dense"
          fullWidth
          value={orderBy}
          onChange={(e) => setOrderBy(e.target.value)}
          style={{ marginBottom: 10 }}
        />

      </Grid>

      <FormControl component="fieldset">
        <FormLabel component="legend">Order By Direction</FormLabel>
        <RadioGroup aria-label="orderByDirection" name="orderByDirection" value={orderByDirection} onChange={(e) => setOrderByDirection(e.target.value)}>
          <Grid
            container
            direction="row"
            justify="flex-start"
            alignItems="flex-start"
          >
            <FormControlLabel value="ASC" control={<Radio />} label="ASC" />
            <FormControlLabel value="DESC" control={<Radio />} label="DESC" />
          </Grid>
        </RadioGroup>
      </FormControl>
    </div>
  );
});


QueueEditNew.propTypes = {
  id: PropTypes.string.isRequired,
};


export default QueueEditNew;
